/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { movePersonAsync } from '../fn/user-ops/move-person-async';
import { MovePersonAsync$Params } from '../fn/user-ops/move-person-async';

@Injectable({ providedIn: 'root' })
export class UserOpsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `movePersonAsync()` */
  static readonly MovePersonAsyncPath = '/userops/move-person';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `movePersonAsync()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  movePersonAsync$Response(params?: MovePersonAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return movePersonAsync(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `movePersonAsync$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  movePersonAsync(params?: MovePersonAsync$Params, context?: HttpContext): Observable<void> {
    return this.movePersonAsync$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
